module.exports = __webpack_public_path__ + "static/media/dI8y1Stwvdb89P8EEbNqhko7aLnrjEOgaWAEJ1kz.9c2623a9.webp";